const HTTP_PROTOCOL = "http";

export const constructHref = (url: string, defaultProtocol = HTTP_PROTOCOL): string => {
    try {
        void new URL(url);

        return url; // if a valid URL is passed, return it as is
    } catch (_) {
        //No need to explicitly handle the error, since we're just trying to construct the URL

        return `${defaultProtocol}://${url}`;
    }
};
